import React from 'react';

// Placeholder cards shown while the single-order read is in flight. The pop-up header and
// stepper are already drawn from the list row, so only the body shimmers.
const Bars: React.FC<{ widths: number[] }> = ({ widths }) => (
  <>
    {widths.map((width, index) => (
      // eslint-disable-next-line react/no-array-index-key
      <i key={index} className="skel" style={{ width: `${width}%` }} />
    ))}
  </>
);

const Card: React.FC<{ widths: number[] }> = ({ widths }) => (
  <section className="op-card">
    <div className="op-card-head">
      <i className="skel skel-title" />
    </div>
    <div className="op-card-body skel-stack">
      <Bars widths={widths} />
    </div>
  </section>
);

const OrderSkeleton: React.FC<{ tabs?: boolean }> = ({ tabs = true }) => (
  <div className="op-skeleton" aria-busy="true" aria-label="Loading order">
    {tabs ? (
      <div className="op-skeleton-tabs">
        <i className="skel" style={{ width: 92 }} />
        <i className="skel" style={{ width: 48 }} />
      </div>
    ) : null}
    <div className="op-grid">
      <div className="op-col">
        <Card widths={[55, 70, 40]} />
        <Card widths={[30, 35]} />
        <Card widths={[60, 75, 45]} />
      </div>
      <div className="op-col">
        <Card widths={[90, 85, 90, 60, 90, 85, 70]} />
      </div>
    </div>
  </div>
);

export default OrderSkeleton;
